const atualizarPlanosManutencao = (state, planosManutencao) => {
    state.planosManutencao = planosManutencao;
}

const atualizarPlanosEquipamento = (state, planosEquipamento) => {
    state.planosEquipamento = planosEquipamento;
}

const atualizarPlanoManutencao = (state, planoManutencao) => {
    state.planoManutencao = planoManutencao;
}

const updatePlanoManutencao = (state, planoManutencao) => {
    const item = state.planosManutencao.find(item => item.id === planoManutencao.id);

    Object.assign(item, planoManutencao);
}

export default {
    atualizarPlanosManutencao,
    atualizarPlanosEquipamento,
    atualizarPlanoManutencao,
    updatePlanoManutencao
}
